import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath'
import { all_routes } from '../router/all_routes'
import { useSelector } from 'react-redux'
import ArrowWhiteRightIcon from '../../icons/ArrowWhiteRightIcon'

const SuccessMessage = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const userDetail = useSelector((state: any) => state.user?.userDetail);
  console.log('userDetail ========= ', userDetail);

  const [successMessageH2, setSuccessMessageH2] = useState<string>("");
  const [successMessageP, setSuccessMessageP] = useState<string>("");
  const [successMessageButton, setSuccessMessageButton] = useState<string>("");

  // Access state passed via `navigate`
  const location = useLocation();
  const { isLogin } = location.state || {}; // Use fallback empty object to avoid errors    
  const isLoginMessage = !!isLogin;
  console.log('isLoginMessage', isLoginMessage);


  useEffect(() => {
    if (isLoginMessage) {
      if (userDetail?.role === "tax_professional" || userDetail?.role?.toLowerCase() === "spouse" || (userDetail?.role?.toLowerCase() === "owner" && userDetail?.has_subscription)) {
        setSuccessMessageH2("Sign in successful.");
        setSuccessMessageP("Welcome aboard! Your account is ready — let’s get started.");
        setSuccessMessageButton("Go to Dashboard");
      }
      else if (userDetail?.role === "owner" && !userDetail?.has_subscription) {
        setSuccessMessageH2("Account Registered Successfully");
        setSuccessMessageP("Redirecting you to the Subscription Plan.");
        setSuccessMessageButton("Go to Subscription Plan");
      }
    }
    else {
      // reset when not login flow
      setSuccessMessageH2("");
      setSuccessMessageP("");
      setSuccessMessageButton("");
    }
  }, [isLoginMessage, userDetail]);


  const navigateTo = () => {
    if (isLoginMessage) {
      if (userDetail?.role?.toLowerCase() == 'spouse') {
        navigate(route.spouseDashboard);
      }
      else if (userDetail?.role?.toLowerCase() == 'tax_professional') {
        navigate(route.cpaDashboard);
      }
      else {
        if (userDetail?.has_subscription) {
          navigate(route.dashboard);
        }
        else {
          navigate(route.pricing);
          // navigate(route.cmsPricing);
        }

      }
    }
    else {
      navigate(route.login);
    }
  };

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper authendication-pages">
        {/* Page Content */}
        <div className="content">
          <div className="container wrapper no-padding">
            <div className="row no-margin align-items-stretch">
              <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
                <div className="banner-bg login">
                  <div className="row h100 pb-0">
                    <div className="col-sm-10 col-md-12 col-lg-12">
                      <div className="row h-100">
                        <div className="col-md-12 h-100">
                          <img
                            src="/assets/img/authImg.jpg"
                            className="object-fit-cover img-fluid w-100"
                            alt="authImg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12  col-lg-4 no-padding d-flex">
                <div className="dull-pg shadow-card w-100">
                  <div className="row h-100 no-margin d-flex align-items-center justify-content-center">
                    <div className="col-sm-10 col-md-10 col-lg-11 mx-auto">
                      <header className="text-center">
                        <ImageWithBasePath
                          src="assets/img/GreenTickIcon.png"
                          className="img-fluid"
                          alt="Logo"
                        />
                      </header>
                      <div className="">
                        <h2 className="text-center">
                          {isLoginMessage ? successMessageH2 : "Password Changed Successfully"}
                        </h2>

                        <p className="text-center">
                          {isLoginMessage ? successMessageP : "Your new password is now active. You're all set to continue securely."}
                        </p>

                        <button
                          onClick={navigateTo}
                          type="submit"
                          className="btn text-white primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                        >
                          {isLoginMessage ? successMessageButton : "Back to Login"}
                          <ArrowWhiteRightIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}
    </>
  )
}

export default SuccessMessage